import React from 'react';
import { ChevronDown, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { locations } from '../../data/site';

export const HeroCallPicker = () => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <Button type="button" className="brand-button" data-testid="hero-call-now-button">
        <Phone size={17} aria-hidden="true" />Call now<ChevronDown size={16} aria-hidden="true" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" sideOffset={8} collisionPadding={16} className="hero-call-picker"
      aria-label="Choose a location to call" data-testid="hero-call-picker">
      {locations.map((location) => (
        <DropdownMenuItem asChild key={location.id}>
          <a href={location.tel} className="hero-call-option" data-testid={`hero-call-option-${location.id}`}>
            {location.name} · {location.phone}
          </a>
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);